
export const ImageElement = ({ value, height = 200 }) => {
    return (
        <>
            {value ? <img style={{ maxHeight: '180px', pageBreakInside: 'avoid' }} src={`data:image/png;base64,${value}`} /> : <></>}
        </>
    )
}